import { z } from "zod";
import { SupportCaseItemSchema } from "./support-cases-item";
import { ResultDataSchema } from "../result-data/result-data";

export const SupportCaseResultSchema = ResultDataSchema.extend({
  Results: SupportCaseItemSchema.array(),
});

export type SupportCaseResultType = z.infer<typeof SupportCaseResultSchema>;
